import script from "./ModalUpdateOrderStatus.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalUpdateOrderStatus.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__